import { useTranslation } from 'react-i18next';
import GoldButton from './GoldButton';

const phone =
  (import.meta.env?.VITE_BRIDE_WHATSAPP as string | undefined) ?? '13059240847';

interface Props {
  className?: string;
}

export default function WhatsAppButton({ className = '' }: Props) {
  const { t } = useTranslation();
  if (!phone) return null;

  const message = encodeURIComponent(t('confirmations.whatsappMessage'));
  const href = `https://wa.me/${phone.replace(/[^0-9]/g, '')}?text=${message}`;

  return (
    <GoldButton
      as="a"
      variant="outline"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      <svg aria-hidden="true" viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
        <path d="M20.52 3.48A11.86 11.86 0 0 0 12.01 0C5.46 0 .14 5.32.14 11.87c0 2.09.55 4.13 1.59 5.94L0 24l6.34-1.66a11.84 11.84 0 0 0 5.66 1.44h.01c6.55 0 11.87-5.32 11.87-11.87 0-3.17-1.23-6.15-3.36-8.43Zm-8.51 18.27h-.01a9.86 9.86 0 0 1-5.03-1.38l-.36-.21-3.76.99 1.01-3.66-.24-.38a9.84 9.84 0 0 1-1.51-5.24c0-5.45 4.43-9.88 9.89-9.88 2.64 0 5.13 1.03 7 2.9a9.83 9.83 0 0 1 2.89 7c0 5.45-4.43 9.86-9.88 9.86Zm5.43-7.4c-.3-.15-1.76-.87-2.04-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.6.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51l-.57-.01c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.49 0 1.47 1.06 2.89 1.21 3.09.15.2 2.09 3.2 5.07 4.49.71.31 1.26.5 1.69.64.71.23 1.36.2 1.87.12.57-.09 1.76-.72 2.01-1.41.25-.69.25-1.28.17-1.41-.07-.13-.27-.2-.57-.35Z" />
      </svg>
      <span>{t('confirmations.whatsappButton')}</span>
    </GoldButton>
  );
}
